<!-- 承运商档案 资质信息 -->
<template>
  <div id="baseInfo">
    <div class="formbox">
      <div class="h3title">营业执照</div>
      <el-form ref="baseInForm" label-width="110px" class="glo_formBox">
        <el-form-item label="企业名称:">
          <el-input v-model="businessIssuing.name" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="营业执照号:">
          <el-input v-model="businessIssuing.employmentNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="核发机关:">
          <el-input v-model="businessIssuing.issuingAuthority" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="发证日期:" label-width="120px">
          <el-date-picker v-model="businessIssuing.issuingDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="生效日期:" label-width="120px">
          <el-date-picker v-model="businessIssuing.validDateStart" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="到期日期:" label-width="120px">
          <el-date-picker v-model="businessIssuing.validDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <div class="uploadBox">
          <div class="uploadItem">
            <div class="uploadLaber">营业执照图片:</div>
            <uploadimgs @input="changeFileList1" :fileNameLists="fileNameLists1" :limit="9"></uploadimgs>
          </div>
        </div>
      </el-form>
      <div class="h3title">道路运输经营许可证</div>
      <el-form label-width="110px" class="glo_formBox">
        <el-form-item label="业户名称:">
          <el-input v-model="daoluYunshuXukeZheng.name" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="营运证号:">
          <el-input v-model="daoluYunshuXukeZheng.employmentNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="核发机关:">
          <el-input v-model="daoluYunshuXukeZheng.issuingAuthority" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="发证日期:" label-width="120px">
          <el-date-picker v-model="daoluYunshuXukeZheng.issuingDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="生效日期:" label-width="120px">
          <el-date-picker v-model="daoluYunshuXukeZheng.validDateStart" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="到期日期:" label-width="120px">
          <el-date-picker v-model="daoluYunshuXukeZheng.validDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="经营范围:">
          <el-input type="textarea" rows="2" v-model="daoluYunshuXukeZheng.businessNature" />
        </el-form-item>
        <div class="uploadBox">
          <div class="uploadItem">
            <div class="uploadLaber">许可证图片:</div>
            <uploadimgs @input="changeFileList2" :fileNameLists="fileNameLists2" :limit="9"></uploadimgs>
          </div>
        </div>
      </el-form>
      <div class="h3title">危险品经营运输许可证</div>
      <el-form label-width="110px" class="glo_formBox">
        <el-form-item label="业户名称:">
          <el-input v-model="weixianPinXukeZheng.name" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="营运证号:">
          <el-input v-model="weixianPinXukeZheng.employmentNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="核发机关:">
          <el-input v-model="weixianPinXukeZheng.issuingAuthority" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="发证日期:" label-width="120px">
          <el-date-picker v-model="weixianPinXukeZheng.issuingDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="生效日期:" label-width="120px">
          <el-date-picker v-model="weixianPinXukeZheng.validDateStart" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="到期日期:" label-width="120px">
          <el-date-picker v-model="weixianPinXukeZheng.validDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="经营范围:">
          <el-input type="textarea" rows="2" v-model="weixianPinXukeZheng.businessNature" />
        </el-form-item>
        <div class="uploadBox">
          <div class="uploadItem">
            <div class="uploadLaber">许可证图片:</div>
            <uploadimgs @input="changeFileList3" :fileNameLists="fileNameLists3" :limit="9"></uploadimgs>
          </div>
        </div>
      </el-form>
    </div>
    <div class="btmBtns">
      <el-button class="glo_bgcMainColor saveBtns" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script >
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  components: { uploadimgs },
  props: {
    common: {
      type: Object,
    },
  },
  emits: ["RELOADPAGE"],
  data() {
    return {
      carrierId: this.common.carrierId,
      fileNameLists1: [],
      fileNameLists2: [],
      fileNameLists3: [],
      businessIssuing: {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
      },
      daoluYunshuXukeZheng: {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
        businessNature: "",
      },
      weixianPinXukeZheng: {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
        businessNature: "",
      },
    };
  },
  watch: {
    common: {
      handler(nv, ov) {
        this.carrierId = nv.carrierId;
        this.GetData();
      },
      deep: true,
    },
  },
  activated() {},
  created() {
    if (this.carrierId) this.GetData();
  },
  methods: {
    changeFileList1(array) {
      this.fileNameLists1 = array;
    },
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },
    changeFileList3(array) {
      this.fileNameLists3 = array;
    },
    RELOADPAGE() {
      this.$emit("RELOADPAGE");
    },

    // 查看图片
    lookImgs({ qualificationType, fileDocumentNumber, fileDocumentStatus }) {
      this.$API
        .filegetFiles({
          documentType: "",
          documentStatus: fileDocumentStatus,
          documentNumber: fileDocumentNumber,
        })
        .then((res) => {
          let filse = res.data.result || [];
          if (filse && filse.length > 0) {
            let arrs = [];
            arrs = filse.map((item) => {
              return {
                name: item.fileId,
                url: item.fileUrl,
              };
            });
            if (qualificationType == "ying_ye_zhi_zhao:qualification_type") {
              this.fileNameLists1 = arrs;
            }
            if (
              qualificationType ==
              "dao_lu_yun_shu_xu_ke_zheng:qualification_type"
            ) {
              this.fileNameLists2 = arrs;
            }
            if (
              qualificationType == "wei_xian_pin_xu_ke_zheng:qualification_type"
            ) {
              this.fileNameLists3 = arrs;
            }
          }
        });
    },
    // 获取承运商单条数据
    async GetData() {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "carrierId",
              conditonVal: this.carrierId,
            },
          ],
          number: "admin_carrier_qualification_info",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((element) => {
              const { qualificationType } = element;
              this.lookImgs(element);
              if (qualificationType == "ying_ye_zhi_zhao:qualification_type") {
                this.businessIssuing = element || {
                  name: "",
                  employmentNumber: "",
                  issuingAuthority: "",
                  issuingDate: "",
                  validDateStart: "",
                  validDateEnd: "",
                };
              }
              if (
                qualificationType ==
                "dao_lu_yun_shu_xu_ke_zheng:qualification_type"
              ) {
                this.daoluYunshuXukeZheng = element || {
                  name: "",
                  employmentNumber: "",
                  issuingAuthority: "",
                  issuingDate: "",
                  validDateStart: "",
                  validDateEnd: "",
                  businessNature: "",
                };
              }
              if (
                qualificationType ==
                "wei_xian_pin_xu_ke_zheng:qualification_type"
              ) {
                this.weixianPinXukeZheng = element || {
                  name: "",
                  employmentNumber: "",
                  issuingAuthority: "",
                  issuingDate: "",
                  validDateStart: "",
                  validDateEnd: "",
                  businessNature: "",
                };
              }
            });
          } else {
            this_.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
    submit() {
      // 正常提交
      // param.contractEndDate = param.contractEndDate
      //   ? `${param.contractEndDate} 23:59:59`
      //   : "";
      // param.contractStartDate = param.contractStartDate
      //   ? `${param.contractStartDate} 00:00:00`
      //   : "";
      this.businessIssuing.fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.daoluYunshuXukeZheng.fileIds = this.fileNameLists2.map((item) => {
        return item.name;
      });
      this.weixianPinXukeZheng.fileIds = this.fileNameLists3.map((item) => {
        return item.name;
      });
      this.$API
        .saveCarrierQualification({
          carrierId: this.carrierId,
          businessIssuing: this.businessIssuing,
          daoluYunshuXukeZheng: this.daoluYunshuXukeZheng,
          weixianPinXukeZheng: this.weixianPinXukeZheng,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.RELOADPAGE();
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
#baseInfo {
  margin: 40px;
  .disFlexs {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .selectAddress {
    border: 1px solid #ccc;
    margin-right: 10px;
    width: 180px !important;
  }
  .addressDetails {
    //   width: 380px !important;
    flex: 1;
  }
  .btmBtns {
    text-align: center;
    margin-top: 50px;

    .saveBtns {
      font-size: 16px;
    }
  }
}
.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  margin-bottom: 20px;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}
.h3title {
  width: 100%;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
